import { Button } from "@zendeskgarden/react-buttons";
import { Modal } from "@zendeskgarden/react-modals";
import styled from "styled-components";
import AlertErrorIcon from "@zendeskgarden/svg-icons/src/16/alert-error-stroke.svg?react";
import { useModal } from "./useModal";
import { ModalProps } from "./modalType";

const CustomModal = styled(Modal)<{ $maxWidth?: string }>`
  max-width: ${({ $maxWidth }) => $maxWidth || "800px"};
  width: 100%;
  margin: 0 auto;
  max-height: 80vh;

  @media (max-width: 914px) {
    max-width: 95%;
    width: 95%;
  }
`;

export default function BaseModal(props: ModalProps) {
  const { handleModalClick } = useModal();

  return (
    <CustomModal
      onClose={props.onClose}
      $maxWidth={props.maxWidth}
      onClick={handleModalClick}
    >
      <Modal.Header tag="h2">
        <p className={props.isDanger ? "text-[#cd3642] flex items-center" : ""}>
          {props.isDanger && <AlertErrorIcon className="mr-2" />}
          {props.title}
        </p>
      </Modal.Header>
      <Modal.Body>{props.children}</Modal.Body>
      <hr className="border-t border-gray-200 my-0 mb-4" />
      <Modal.Footer>
        {props.onClose && (
          <Modal.FooterItem>
            <Button onClick={props.onClose} isBasic>
              {props.buttonCloseTitle}
            </Button>
          </Modal.FooterItem>
        )}
        {props.onClick && (
          <Modal.FooterItem>
            <Button isPrimary onClick={props.onClick} isDanger={props.isDanger} disabled={props.isConfirmDisabled}>
              {props.buttonTitle}
            </Button>
          </Modal.FooterItem>
        )}
      </Modal.Footer>
      {!props.hideCloseIcon && <Modal.Close aria-label="Close modal" />}
    </CustomModal>
  );
}
